import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PrevisaoCompraService } from '../previsao-compra-service/previsao-compra.service';
import { ConversaoLibraConverte } from './../../../../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from './../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { RetornoSelecao } from './../../../../shared/gridview/RetornoSelecao';
import { Parametro } from './../../../../shared/service-base/parametro';

@Component({
  selector: 'app-previsao-compra-lista',
  templateUrl: './previsao-compra-lista.component.html',
  styleUrls: ['./previsao-compra-lista.component.css']
})
export class PrevisaoCompraListaComponent
  extends ListaBase
  implements OnInit {
  previsaoCompra: any;
  cols: any[];
  _selectedColumns: any[];
  parametrosFiltro: any;
  carregando: boolean;
  removeSelecionado = [];
  first = 0;
  rows = 10;
  subscription;

  dadosTranslate = {
    "Categoria Compra": "parametros.previsaoCompra.categoriaCompra",
    "Ano": "parametros.previsaoCompra.ano",
    "Mês": "parametros.previsaoCompra.mes",
    "Valor": "parametros.previsaoCompra.valor",
    "Remover": "parametros.previsaoCompra.remover",
  }

  constructor(service: PrevisaoCompraService,
    toastr: ToastrService,
    router: Router,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.carregarFiltrosParametros();
      this.router = router;
    });
  }

  ngOnInit() {
    this.buscar();
    this.cols = [
      { field: 'detalhe', header: ''},
      { field: 'nome_dealer', header: 'Dealer' },
      { field: 'nome_categoria_compra', header: 'parametros.previsaoCompra.categoriaCompra' },
      { field: 'ano', header: 'parametros.previsaoCompra.ano' },
      { field: 'mes', header: 'parametros.previsaoCompra.mes' },
      { field: 'valor', header: 'parametros.previsaoCompra.valor' },
      { field: 'remover', header: 'parametros.previsaoCompra.remover' }
    ];

    this._selectedColumns = this.cols;
    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  
  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.id_dealer
      || this.filtros.id_categoria_compra
      || this.filtros.mes
      || this.filtros.ano;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  buscar() {
    this.carregando = true;

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.service.buscar(objFiltro).then(res => {
      res.dados.forEach(dados => {
          dados.valor = this.conversaoLibraConverte.conversaoLibra(dados.valor, null, null).toFixed(2);

      });
      this.previsaoCompra = res.dados;

      this.carregando = false;
    });
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.service ? this.first === (this.service.length - this.rows) : true;
  }

  isFirstPage(): boolean {
    return this.service ? this.first === 0 : true;
  }

  visualizar(registro) {
    const retorno: RetornoSelecao = new RetornoSelecao();
    retorno.novoCadastro = false;
    retorno.registro = registro;
    this.ver(retorno);
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  ngAfterViewChecked() {
   
  }

  marcarRemoverSelecionados(dados){
    if(this.removeSelecionado.indexOf(dados.id) == -1){
      this.removeSelecionado.push(dados.id);
    }else{
      this.removeSelecionado.splice(this.removeSelecionado.indexOf(dados.id),1);
    }
  }

  RemoverSelecionados(){
    for (let i = 0; i < this.removeSelecionado.length; i++) {
      this.service.excluir(this.removeSelecionado[i]);
    }
    const mensagem = 'Registro(s) selecionado(s) sendo Excluido(s)';
    this.toastr.success(mensagem, 'Excluido(s)');
    this.removeSelecionado = [];
    setTimeout(() =>{ 
      this.buscar();
     }, 3000);
    
  }

}
